<section class="example-section" [formGroup]="services">
    <h4 i18n="@@service-selector-heading">Services</h4>
    @for (service of serviceDefs; track service; let i = $index) {
    <p>
        <mat-checkbox [formControlName]="service.id" (change)="selectionChanged()">{{ service.text }}</mat-checkbox>
    </p>
    }
</section>
